import { motion } from "framer-motion";

const IntroSplash = () => (
    <motion.div
        data-testid="intro-splash"
        exit={{ y: "-100%" }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        className="fixed inset-0 z-[100] flex items-center justify-center bg-noir"
    >
        <div
            aria-hidden="true"
            className="absolute h-[440px] w-[440px] rounded-full bg-blush/40 blur-[130px]"
        />
        <motion.img
            data-testid="intro-logo"
            src="/logo.png"
            alt="Yasmim Alves — Nail Designer"
            initial={{ opacity: 0, scale: 0.82, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-64 sm:w-80"
        />
    </motion.div>
);

export default IntroSplash;
